import React from 'react';
import { Button, Popconfirm } from 'antd';

const ConfirmDeleteButton = ({ confirm, onDelete, ...buttonProps }) =>
	confirm ? (
		<Popconfirm
			title={confirm}
			okText="Delete"
			okButtonProps={{ danger: true }}
			onConfirm={onDelete}
		>
			<Button danger {...buttonProps} />
		</Popconfirm>
	) : (
		<Button danger {...buttonProps} onClick={onDelete} />
	);

export default ConfirmDeleteButton;
